import React from 'react';
import { FormatText } from '@/components/ui/FormatText';

interface RecruiterNotesTabProps {
  notes: string[];
}

export function AnalysisRecruiterNotesTab({ notes }: RecruiterNotesTabProps) {
  return (
    <div className="space-y-4">
      {notes.length === 0 ? (
        <p className="text-sm text-slate-600 dark:text-slate-400">No recruiter notes available.</p>
      ) : (
        <ul className="list-disc pl-5 space-y-3 text-sm font-mono text-slate-700 dark:text-slate-300">
          {notes.map((note, i) => (
            <li key={i} className="leading-relaxed pl-1">
              <FormatText text={note} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
